module.exports = __webpack_public_path__ + "img/banner.4373ca2f.jpg";